import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { SelectWithLabel, ButtonTag } from 'components/Form'
import Tooltip from './Tooltip'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const Selector = ({ label, placeholder, options, value, onChange, link, tooltip, isDisabled, isRequired, isClearable, loading, error }) => (
  <div className='smartchat-field selector'>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <SelectWithLabel
        options={options}
        value={!loading ? value : null}
        placeholder={!loading ? placeholder : null}
        onChange={onChange}
        isDisabled={isDisabled}
        isClearable={isClearable}
        classNameWrapper={`${isDisabled ? 'selector--disabled' : ''} ${!loading && error ? 'selector--error' : ''}`}
        fullWidth
      />
      {loading && <Nixi1Spinner width='30px' height='30px' />}
      {!loading && typeof error === 'string' && (
        <Tooltip
          icon={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')}
          message={error}
        />
      )}
      {!loading && link && (
        <ButtonTag
          icon={<img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='External link' />}
          value={link.text}
          onClick={link.event}
        />
      )}
      {!loading && tooltip && (
        <Tooltip
          width='20px'
          icon={tooltip.icon}
          message={tooltip.message}
        />
      )}
    </div>
  </div>
)

export default Selector
